import { render, staticRenderFns } from "./NewProductComboModal.vue?vue&type=template&id=1c0160f1"
import script from "./NewProductComboModal.vue?vue&type=script&lang=js"
export * from "./NewProductComboModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports